<div class="p-a-xl" fxLayout="column">
    <div fxLayout class="m-b">
        <div fxFlexOffset="10" fxLayout fxFlex>
            @for (item of textsSizes; track $index) {
                <p fxFlex class="cipo-text--bold-lg cipo--text--center">{{ item }} text</p>
            }
        </div>
    </div>
    @for (size of dialogsSizes; track $index) {
        <div fxLayout class="cipo--border-bottom--lite p-b-sm m-b">
            <p fxFlex="10" class="cipo-text--bold-lg cipo--text--end">{{ size }} dialog</p>
            @for (text of textsSizes; track $index) {
                <div fxFlex fxLayoutAlign="center" fxLayoutGap="12px">
                    <button mat-raised-button (click)="openConfirmationDialog(size, text)" color="primary">
                        Confirmation
                    </button>
                    <button mat-raised-button (click)="openInfoDialog(size, text)" color="accent">Info</button>
                </div>
            }
        </div>
    }
</div>
